export function chunkFailureUrl(error: unknown): string | null {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  if (!/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message)) return null;
  const match = message.match(/https?:\/\/[^\s"'<>]+|\/assets\/[^\s"'<>]+/);
  if (!match) return null;
  try {
    const url = new URL(match[0], window.location.href);
    return url.origin === window.location.origin && url.pathname.startsWith('/assets/') && url.pathname.endsWith('.js') ? url.href : null;
  } catch { return null; }
}

// User gesture only: no automatic reload, no clearing persisted drafts or login.
export function reloadChunkOnce(failedUrl: string, version: string, env: {
  online: () => boolean;
  confirm: (message: string) => boolean;
  storage: () => Pick<Storage, 'getItem' | 'setItem'>;
  reload: () => void;
}): string | null {
  if (!env.online()) return 'Sem conexão. Reconecte e tente novamente.';
  if (!env.confirm('Recarregar pode descartar alterações e rascunhos não salvos. Deseja continuar?')) return 'Recarregamento cancelado. Nenhum reload foi iniciado.';
  const key = `crm:chunk-reload:${encodeURIComponent(version)}:${encodeURIComponent(failedUrl)}`;
  try {
    const storage = env.storage();
    if (storage.getItem(key)) return 'Esta versão já tentou recarregar este módulo. Não repetiremos automaticamente. Use Ctrl+F5 somente após salvar seus dados.';
    storage.setItem(key, '1');
  } catch { return 'Não foi possível registrar a tentativa. Para evitar ciclos, use Ctrl+F5 manualmente após salvar seus dados.'; }
  env.reload();
  return null;
}

export function loadedEntryVersion(): string {
  return document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.src || 'unknown-entry';
}
